import './index.css';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

import { I18nextProvider } from "react-i18next";
import i18n from "./LocalizationHelper";

import { createRoot } from 'react-dom/client';
const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<I18nextProvider i18n={i18n}><App tab="home" /></I18nextProvider>);

//import * as serviceWorker from './serviceWorker';

// ReactDOM.render(
//     <I18nextProvider i18n={i18n}>
//         <App />
//     </I18nextProvider>,
//     document.getElementById('root')
// );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
